import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { Header } from "@/components/Header";
import { CookieBanner } from "@/components/CookieBanner";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { TrufflePage } from "@/pages/TrufflePage";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { TruffleSpotlight } from "@/components/TruffleSpotlight";
import { ProductCatalog } from "@/components/ProductCatalog";
import { WhyUs } from "@/components/WhyUs";
import { Certifications } from "@/components/Certifications";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { MessageCircle } from "lucide-react";

function HomePage() {
    return (
        <div className="grain min-h-screen bg-[#1C2029] font-body text-white antialiased" data-testid="app-root">
            <Header />
            <main>
                <Hero />
                <EditorialMarquee />
                <Manifesto />
                <TruffleSpotlight />
                <ProductCatalog />
                <WhyUs />
                <Certifications />
                <ContactSection />
            </main>
            <Footer />
            <a
                data-testid="whatsapp-float"
                href="https://wa.me/393393506050"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-midora-red text-white shadow-[0_0_30px_rgba(163,0,54,0.4)] transition-transform duration-300 hover:scale-110"
            >
                <MessageCircle className="h-6 w-6" />
            </a>
            <CookieBanner />
            <Toaster position="top-center" theme="dark" />
        </div>
    );
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <LanguageProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/tartufi" element={<TrufflePage />} />
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
